import { Suspense } from 'react';
import { GrillaEl, PilaV } from '../atomos';
import { Outlet } from 'react-router-dom';
import Cabecera from '../organismos/Cabecera/Cabecera';
import { useMediaQuery } from '@chakra-ui/react';
import { TituloProvider } from '@/hooks/ContextoTituloCabecera';
import CargandoPantallaCompleta from './CargandoPantallaCompleta';

const ContenedorPaginas = () => {
  const [mobile] = useMediaQuery('( max-width: 768px )');
  return (
    <TituloProvider>
      <GrillaEl
        flexGrow={1}
        as={PilaV}
        w={'full'}
        maxW={'full'}
        px={mobile ? 4 : 10}
        pb={8}
        colSpan={1}
        overflowX={'hidden'}
      >
        <Cabecera />
        <Suspense fallback={<CargandoPantallaCompleta />}>
          <Outlet />
        </Suspense>
      </GrillaEl>
    </TituloProvider>
  );
};

export default ContenedorPaginas;
